// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3aeZb","sendOtp":"AuthorizeToLogin_sendOtp__3EqCG"};